import { render, staticRenderFns } from "./OrderDettails.vue?vue&type=template&id=50257604&"
import script from "./OrderDettails.vue?vue&type=script&lang=js&"
export * from "./OrderDettails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports